import {
  Box,
  Checkbox,
  DashboardModuleListItem,
  ListItem,
  Text,
} from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import useAdAccountGroupAdAccount, { useRelations } from '@hooks/useAdAccountGroupAdAccount'

import type { AdAccountGroupAdAccountModel } from '@models/types'

const generateAdAccountTypeTitle = (adAccountType: string) => {
  const adAccountTypeMap = {
    FacebookAdAccount: 'Ad Account',
    FacebookPage: 'Page',
    FacebookPixel: 'Pixel',
    FacebookUser: 'User',
    GoogleAdAccount: 'Google MCC',
  } as { [key: string]: string }

  return adAccountTypeMap[adAccountType]
}

interface AdAccountListItemProps {
  adAccountGroupAdAccount: AdAccountGroupAdAccountModel,
}

const AdAccountListItem = (props: AdAccountListItemProps) => {
  const { adAccountGroupAdAccount } = props

  const {
    callbacks: {
      deleteAdAccountGroupAdAccount: deleteFn,
    },
  } = useAdAccountGroupAdAccount(adAccountGroupAdAccount)

  const { adAccount } = useRelations(adAccountGroupAdAccount)
  const { accountReferenceId, adAccountType, name } = adAccount

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      deleteString: 'Remove',
      entityName: 'Ad Account',
    },
  }

  const adAccountTypeTitle = generateAdAccountTypeTitle(adAccountType)

  return (
    <ListItem.WithCheckbox
      boxProps={{ paddingX: 'large', paddingY: 'small' }}
      checkbox={<Checkbox checked fontSize="small" />}
      disableHover
    >
      <Box alignItems="center">
        <Box flexDirection="column">
          <Text color="bodyFontLightColor" fontSize="xsmall">Linked {adAccountTypeTitle}</Text>

          <Text fontSize="small">{name}</Text>
        </Box>

        <Text color="bodyFontLightColor" fontSize="small">{accountReferenceId}</Text>
      </Box>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
      </DashboardModuleListItem.Actions>
    </ListItem.WithCheckbox>
  )
}

export default AdAccountListItem